module.exports = __webpack_public_path__ + "img/banner_nanirestaurant.3f0a623.JPG";